import logo from '../../assets/images/logo.svg'
import { TermsModal } from '../../components/molecules'
import pdf from '../../assets/documents/terms-of-use.pdf'
import { ReactElement, useCallback, useEffect } from 'react'
import { updateUserProfile } from '../../libs/services'
import { useAuth } from '../../hooks/useAuth'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { PageTitle, SkipLink } from '../../components/atoms'
import { logger } from '../../utils'
import { getPostLoginDestination } from '../../utils/deeplink'

export const pageTitle = 'Privacy and Terms of Use Agreement'
export const idTermsPageMainContent = 'welcome-page-main-content'

const Terms = (): ReactElement => {
  const { userProfile, setUserProfile } = useAuth()
  const navigate = useNavigate()

  const navigateAfterTerms = useCallback(() => {
    const destination = userProfile?.role?.slug === 'admin' ? '/dashboard/all-assigned-students' : getPostLoginDestination()
    logger.log('navigateAfterTerms', { role: userProfile?.role?.slug, destination })
    navigate(destination)
  }, [navigate, userProfile])

  useEffect(() => {
    if (userProfile === null || userProfile === undefined) {
      navigate('/')
    } else if (userProfile?.user_profile?.accepted_terms) {
      void navigateAfterTerms()
    }
  }, [userProfile, navigate, navigateAfterTerms])

  const handleAcceptTerms = useCallback((setIsSubmitting: React.Dispatch<boolean>) => {
    setIsSubmitting(true)
    updateUserProfile({ accepted_terms: true })
      .then((res) => {
        if (res !== null || res !== undefined) {
          const updatedProfile = res?.data?.data
          logger.log('Terms accepted, navigating after terms')
          setUserProfile({ ...userProfile, user_profile: updatedProfile })
          void navigateAfterTerms()
        } else {
          toast.error('Unable to update user profile', {
            position: toast.POSITION.TOP_CENTER
          })
        }
        setIsSubmitting(false)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER
        })
        setIsSubmitting(false)
      })
  }, [navigateAfterTerms, setUserProfile, userProfile])
  return (
    <div className='bg-black min-h-screen font-primary items-center flex justify-center'>
      <SkipLink targetId={idTermsPageMainContent} />
      <header className='absolute left-[40px] top-[40px]'>
        <img src={logo} className='w-[138px]' alt='DopaGE Logo' />
      </header>

      <main
        id={idTermsPageMainContent}
        tabIndex={-1}
      >
        <PageTitle title={pageTitle} />
        <section className='flex justify-center'>
          <TermsModal pdfUrl={pdf} handleAcceptTerms={handleAcceptTerms} />
        </section>
      </main>
      <footer className='sr-only' />
    </div>
  )
}

export default Terms
